import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
  currentMenu: {},
  userInfo: {},
  currentOpenMenu: '/project',
  showSideNav: false,
  dictionary: {},
  /* menuList: [
    { icon: 'fa fa-fw fa-1x fa-plug', title: '首页', url: '/' },
    { icon: 'fa fa-fw fa-1x fa-plug', title: '产品', url: '/product' },
    {
      icon: 'fa fa-fw fa-1x fa-mortar-board',
      title: '设备管理',
      url: '/device',
      children: [
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '设备管理',
          url: '/device',
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '分组管理',
          url: '/group',
        },
      ],
    },
    { icon: 'fa fa-fw fa-1x fa-plug', title: '插件', url: '/plugins' },
    { icon: 'fa fa-fw fa-1x fa-shekel', title: '规则', url: '/rules' },
    { icon: 'fa fa-fw fa-1x fa-users', title: '客户', url: '/customers' },
    { icon: 'fa fa-fw fa-1x fa-home', title: '项目管理', url: '/project' },
    {
      icon: 'fa fa-fw fa-1x fa-mortar-board',
      title: '平台管理',
      url: '/platform',
      children: [
        // { icon: 'fa fa-fw fa-1x fa-mortar-board', title: '平台设置', url: '/1-1' },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '平台用户',
          url: '/platform/users',
        },
      ],
    },
    {
      icon: 'fa fa-fw fa-1x fa-drivers-license',
      title: '授权管理',
      url: '/authority',
      children: [
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '子账号管理',
          url: '/authority/subaccount',
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '授权管理',
          url: '/authority/role',
        },
      ],
    },
    {
      icon: 'fa fa-fw fa-1x fa-puzzle-piece',
      title: '小部件库',
      url: '/widgets',
    },
    {
      icon: 'fa fa-fw fa-1x fa-th-large',
      title: '仪表板库',
      url: '/dashboards',
    },
  ], */
  menuList: [
    {
      icon: 'fa fa-fw fa-1x fa-home',
      title: '商品库',
      url: '/product',
      children: [
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '商品管理',
          url: '/product-list',
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '推荐商品',
          url: '/recommend-list',
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '积分商品',
          url: '/integral-list',
        },
      ],
    },
    {
      icon: 'fa fa-fw fa-1x fa-list',
      title: '订单管理',
      url: '/order',
      children: [
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '订单列表',
          url: '/order-list',
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '退款管理',
          url: '/refund-list',
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '评价管理',
          url: '/evaluation-list',
        },
      ],
    },
    {
      icon: 'fa fa-fw fa-1x fa-cny',
      title: '系统设置',
      url: '/config',
      children: [
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '佣金积分',
          url: '/commission-points',
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '优惠券',
          url: '/coupon',
        },
      ],
    },
    { icon: 'fa fa-fw fa-1x fa-users', title: '会员管理', url: '/member-list' },
    { icon: 'fa fa-fw fa-1x fa-user-secret', title: '账号管理', url: '/account-list' },
  ],
  currentProjectId: window.localStorage.getItem('CURRENT_PROJECT_ID') || '',
  authUrlList: {},
  superTenantId: '1',
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  strict: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/store/index.js